import { MiniBetSlipSchema } from './MiniBetSlip.styles';

export const defaultStyles: MiniBetSlipSchema = {
  wrapper: {
    bottom: '0',
    left: '0',
    position: ['fixed', null, null, 'sticky'],
    right: '0',
    zIndex: 'sticky',
  },
  slideBox: {
    bgGradient: 'linear(to-tr, beta.300, beta.200)',
    color: 'white',
    mb: '-4',
  },
  accordionItem: {
    borderTopWidth: '0',
    _last: {
      borderBottomWidth: '0',
    },
  },
  accordionHeaderText: {
    boxShadow:
      '0 1px rgba(255, 255, 255, .15), 0 1px rgba(255, 255, 255, .15) inset',
  },
  accordionButton: {
    bg: 'blackAlpha.300',
    fontSize: 'xs',
    fontWeight: 'bold',
    gap: '1',
    p: '2',
  },
  accordionButtonIcon: {
    fontSize: 'sm',
  },
  headerStack: {
    bg: 'alpha.900',
    borderRadius: 'base',
    bottom: '100%',
    fontSize: 'xs',
    fontWeight: 'medium',
    left: '50%',
    pos: 'absolute',
    px: '4',
    py: '2',
  },
  headerText: {
    flex: '1',
  },
  headerButton: {
    display: 'inline-flex',
    fontSize: 'xl',
    minW: '0',
  },
  accordionPanel: {
    fontSize: 'xs',
    maxH: '32',
    overflow: 'auto',
    p: '0',
  },
  selectionFlex: {
    borderColor: 'blackAlpha.300',
    gap: '2',
    p: '2',
    pos: 'relative',
    _notFirst: {
      borderTopStyle: 'dotted',
      borderTopWidth: '1px',
    },
    _before: {
      border: 'inherit',
      borderColor: 'whiteAlpha.300',
      content: '""',
      h: '1px',
      left: '0',
      pos: 'absolute',
      right: '0',
      top: '0',
    },
  },
  selectionMarketName: {
    flex: '1',
    fontWeight: 'bold',
  },
  selectionPropositionName: {
    flex: ['1', null, '2', null, '3'],
  },
  footerStack: {
    bgGradient: 'linear(to-b, rgba(194, 223, 255, .1), rgba(194, 223, 255, 0))',
    borderColor: 'whiteAlpha.300',
    direction: 'row',
    fontSize: 'sm',
    fontWeight: 'semibold',
    p: '2',
    pb: [null, null, null, '4'],
    pos: 'relative',
    _before: {
      bgGradient: 'linear(to-b, rgba(0, 0, 0, 0), rgba(0, 0, 0, .2))',
      bottom: 'calc(100% + 1px)',
      content: '""',
      h: '17px',
      left: '0',
      pointerEvents: 'none',
      pos: 'absolute',
      right: '0',
      transitionDuration: 'normal',
      transitionProperty: 'common',
    },
  },
  footerHStack: {
    flex: '1',
  },
  legsText: {
    flex: '1',
  },
  legsChunks: {
    color: 'alpha.500',
    fontSize: 'md',
    fontWeight: 'black',
  },
  oddsText: {
    flex: '2',
  },
  oddsSkeletonLoader: {
    display: 'inline-block',
    ml: '1',
    w: '8',
  },
  oddsChunks: {
    color: 'alpha.500',
    fontSize: 'md',
    fontWeight: 'black',
    ml: '1',
  },
  clearButton: {
    variant: 'outline',
    fontFamily: 'roboto',
    fontSize: 'xs',
    px: '3',
    w: 'auto',
  },
  addToSlipButton: {
    fontFamily: 'roboto !important',
    fontSize: 'xs',
    px: '3',
    w: 'auto',
  },
};
